import React from 'react';
import Annex6TableRows from './Annex6TableRows';
import { TAnnex6BackendRecord } from 'redux/app/annex6/@types';
import getSignTableRows from './getSignTableRows';
type OwnProps = {
    isSubmitterChiefOrMaster: boolean;
    annex6Record: TAnnex6BackendRecord;
    theme?: "light" | "dark";
};
type Annex6RecordParticipantsViewProps = OwnProps;
function Annex6RecordParticipantsView(
    props: Annex6RecordParticipantsViewProps
) {
    const { annex6Record } = props;

    return (
        <Annex6TableRows
            record={annex6Record}
            tableRows={getSignTableRows(annex6Record)}
        />
    );
}

export default Annex6RecordParticipantsView;
